import applyRouteFetchMapping from "shared/redux-store/applyRouteFetchMapping";

const fetcherMiddlewareFactory =
  routeFetchMapping => store => next => action => {
    if (action.type !== "@@router/LOCATION_CHANGE") {
      return next(action);
    }

    // Note we can use other url aspects here, too (not only path)
    const { routing } = store.getState();
    const { pathname } = action.payload;
    const prevPathname =
      routing.locationBeforeTransitions &&
      routing.locationBeforeTransitions.pathname;

    if (pathname === prevPathname) {
      return next(action);
    }

    const fetchActions = applyRouteFetchMapping(routeFetchMapping, pathname);

    fetchActions.forEach(fetchAction => {
      store.dispatch(fetchAction);
    });

    return next(action);
  };

export default fetcherMiddlewareFactory;
